const trimmedLengthIsTen = (string) => {
  return string.replace(/\D/g,'').length===10
}

export default trimmedLengthIsTen;
